// extracted by mini-css-extract-plugin
export var container = "_az-0";